import { Carrier } from "@/core/enums/carriers.enum";
import { globals } from "@/core/globals";
import type { ICurrency } from "@/core/types";
import type { ShippingChoiceType } from "@/shared/checkout";

export function getShippingOptionFriendlyName(choice: string, isOrderSummary?: boolean) {
  if (globals.shippingOptionsFriendlyNames[choice]) {
    return globals.shippingOptionsFriendlyNames[choice];
  }

  if (isOrderSummary) {
    return choice;
  }

  return choice.replace(Carrier.FedEx, "").replace(Carrier.UPS, "").replace(Carrier.DHL, "").trim();
}

function createCurrencyData(currency: ICurrency) {
  return {
    code: currency.code,
    symbol: currency.symbol,
    cultureName: currency.cultureName,
    englishName: currency.englishName,
    exchangeRate: currency.exchangeRate,
    customFormatting: currency.customFormatting,
  };
}

function createEmptyPriceData() {
  return {
    amount: 0,
    currency: {
      code: "",
      cultureName: "",
      customFormatting: undefined,
      englishName: "",
      exchangeRate: 0,
      symbol: "",
    },
    decimalDigits: 0,
    formattedAmount: "",
    formattedAmountWithoutCurrency: "",
    formattedAmountWithoutPoint: "",
    formattedAmountWithoutPointAndCurrency: "",
  };
}

export function buildShippingMethod(
  selected: ShippingChoiceType | undefined,
  isOnlySpecial: boolean,
  currencyData: ICurrency,
) {
  return {
    id: selected?.rateModeId ?? "Special",
    code: isOnlySpecial ? "Special" : "Carrier",
    optionName: isOnlySpecial ? "Special" : selected?.modeText ?? "",

    currency: createCurrencyData(currencyData),
    total: {
      ...createEmptyPriceData(),
      amount: isOnlySpecial ? 0 : selected?.totalFreightAmount ?? 0,
    },
    price: {
      ...createEmptyPriceData(),
      amount: isOnlySpecial ? 0 : selected?.totalFreightAmount ?? 0,
    },
    discountAmount: createEmptyPriceData(),
    discountAmountWithTax: createEmptyPriceData(),
    priceWithTax: createEmptyPriceData(),
    priority: 0,
    totalWithTax: createEmptyPriceData(),
  };
}
